import { render, staticRenderFns } from "./Foundation.vue?vue&type=template&id=54044450&"
import script from "./Foundation.vue?vue&type=script&lang=js&"
export * from "./Foundation.vue?vue&type=script&lang=js&"
import style0 from "./Foundation.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports